import FieldConfig from "../../proto/field-config"
import FieldProject from "../entity/project/project"
import FieldProjectPath_GlistView from "./render/glist/glist-view"
import FieldProjectPath_ViewProperty from "./render/view-property";

export default class FieldProjectPath extends FieldProject {


    constructor(config:FieldConfig) {
        super(config)

        this.maxParents                         = _.get(config, 'maxParents', 3);

        this.renderComponents.glistView         = FieldProjectPath_GlistView
        this.renderComponents.viewProperty      = FieldProjectPath_ViewProperty
    }

}
